export const environment = {
  production: false,
  apiUrl: 'https://api.agencymarz.com/api',
};
